export default "__VITE_ASSET__CeqxqThu__"